export const IconApps = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" stroke="none" width="18" height="18">
    <circle cx="5"  cy="5"  r="1.6"/>
    <circle cx="12" cy="5"  r="1.6"/>
    <circle cx="19" cy="5"  r="1.6"/>
    <circle cx="5"  cy="12" r="1.6"/>
    <circle cx="12" cy="12" r="1.6"/>
    <circle cx="19" cy="12" r="1.6"/>
    <circle cx="5"  cy="19" r="1.6"/>
    <circle cx="12" cy="19" r="1.6"/>
    <circle cx="19" cy="19" r="1.6"/>
  </svg>
);

export const IconBack = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
       strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
    <polyline points="15 18 9 12 15 6"/>
  </svg>
);

export const IconChevron = () => (
  <svg className="cp-sep" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6"/>
  </svg>
);

export const IconPinFilled = () => (
  <svg className="pin-star" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 17.3 18.2 21l-1.6-7 5.4-4.7-7.1-.6L12 2 9.1 8.7 2 9.3 7.4 14 5.8 21z"/>
  </svg>
);

export const IconPinOutline = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="17" x2="12" y2="22"/>
    <path d="M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24Z"/>
  </svg>
);
